import {useDispatch, useSelector} from 'react-redux';
import {useEffect, useState} from "react";
import Pref from "../inc/Pref";
import {userLoggedIn} from "../store/userSlice";
import Api from "../inc/Api";
import {setStg, stg} from "../inc/Utils";

function Auth(props) {

    const dispatch = useDispatch();

    const [sessionToken] = useState(Pref.sessionToken);
    const [sessionUser] = useState(Pref.sessionUser);

    useEffect(() => {
        console.log('initialView');

        if (sessionUser) {
            dispatch(userLoggedIn(sessionUser));
        }

        Api.get('/admin/verify', rsp => {
            if (rsp.ok) {
                if (rsp.user.data) {
                    Pref.sessionUser = rsp.user.data;
                    dispatch(userLoggedIn(rsp.user.data));
                    console.log('rsp.user.data', rsp.user.data);
                } else {
                    console.log('no logged');
                }

                setStg(rsp.user.settings);

            } else {
                console.log('err');
            }
        });
    }, []);

    return (
        <div>
            {props.children}
        </div>
    );
}

export default Auth;